import React from "react";

const MessageActivityDetailsMessageContent = ({ data }: { data: any }) => {
  return (
    <div>
      {data?.data?.channel === "email" && (
        <div className="space-y-6 pl-2 pt-1">
          <h3 className="text-lg font-bold">Message Content</h3>
          <div className="border rounded-lg bg-background">
            <div className="border-b p-4 bg-muted/30">
              <p className="text-xs text-muted-foreground mb-1">Subject:</p>
              <h6 className="text-sm font-medium">
                {data?.data?.content?.subject || "No subject"}
              </h6>
            </div>
            <div className="p-4">
              <div
                className="text-sm"
                dangerouslySetInnerHTML={{
                  __html: data?.data?.content?.rawTemplate || "No content",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageActivityDetailsMessageContent;
